<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="row justify-content-between align-items-center mb-2 zIndexUp">
      <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2"> Product Management</h4>
      <ul
        class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-12 col-sm-12 mb-0 d-flex align-items-center flex-wrap">

        <li *ngIf="permission.Product_Filter==1 || userRId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-info border-info btn" (click)="openClosefun()">
            <span class="mdi mdi-filter"></span>Filter</a></li>
        <li *ngIf="permission.Product_Export==1 || userRId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-primary border-primary " (click)="ExportOpenModal(exportConfirm)"><span
              class="mdi mdi-export"></span>
            Export</a></li>
        <li *ngIf="permission.Product_Import==1 || userRId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-danger border-danger" (click)="importDocument.show()"><span
              class="mdi mdi-import"></span>
            Import</a></li>
        <li *ngIf="permission.Product_Add==1 || userRId==1"> <a href="javascript:void(0);"
            routerLink="/productmanagment/addproduct" class="btn btn-sm btn-light-info"><span
              class="mdi mdi-plus"></span>Add Product</a></li>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-12">
        <ngb-tabset #t="ngbTabset" (tabChange)="changeTab($event)">
          <ngb-tab *ngFor="let item of businessStream; index as i;" id="tab-selectbyid-{{item.id}}">
            <ng-template ngbTabTitle>
              <div>{{item.itemName}}</div>
            </ng-template>
            <ng-template ngbTabContent>
              <div class="card" *ngIf="isCollapsed">
                <div class="card-body cb-pad-adjust">
                  <div class="form-row d-flex">
                    <div class="col-lg-2 col-md-6 mb-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['Category']}}
                      </label>
                      <angular2-multiselect [settings]="dropdownSettings" [data]="businessCategory"
                        [ngvalue]="businessCategoryList" [(ngModel)]="selectedBusinessCategory"
                        (onSelect)="onBusinessCategorySelect($event)" (onDeSelect)="onBusinessCategorySelect($event)"
                        (onSelectAll)="onBusinessCategorySelect($event)"
                        (onDeSelectAll)="onBusinessCategorySelect($event)" fixSearchBug>
                      </angular2-multiselect>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['Group']}}
                      </label>
                      <angular2-multiselect [settings]="dropdownSettings" [data]="productGroup"
                        [(ngModel)]="selectedProductGroup" (onSelect)="onProductGroupSelect($event)"
                        (onDeSelect)="onProductGroupSelect($event)" (onSelectAll)="onProductGroupSelect($event)"
                        (onDeSelectAll)="onProductGroupSelect($event)" fixSearchBug></angular2-multiselect>
                    </div>
                    <div class="col-lg-2 col-md-6 mb-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['ProductType']}}
                      </label>
                      <angular2-multiselect [settings]="dropdownSettings" [data]="productType"
                        [(ngModel)]="selectedProductType" (onSelect)="onProductTypeSelect($event)"
                        (onDeSelect)="onProductTypeSelect($event)" (onSelectAll)="onProductTypeSelect($event)"
                        (onDeSelectAll)="onProductTypeSelect($event)" fixSearchBug></angular2-multiselect>
                    </div>
                    <div class="col-lg-2 col-md-6 mb-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['Brand']}}</label>
                      <angular2-multiselect [settings]="dropdownSettings" [data]="productBrand"
                        [(ngModel)]="selectedProductBrand" (onSelect)="onProductBrandSelect($event)"
                        (onDeSelect)="onProductBrandSelect($event)" (onSelectAll)="onProductBrandSelect($event)"
                        (onDeSelectAll)="onProductBrandSelect($event)" fixSearchBug></angular2-multiselect>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['Series']}}</label>
                      <angular2-multiselect [settings]="dropdownSettings" [data]="productSeries"
                        [(ngModel)]="selectedProductSeries" (onSelect)="onProductSeriesSelect($event)"
                        (onDeSelect)="onProductSeriesSelect($event)" (onSelectAll)="onProductSeriesSelect($event)"
                        (onDeSelectAll)="onProductSeriesSelect($event)" fixSearchBug>
                      </angular2-multiselect>
                    </div>

                    <div class="col-lg-2 col-md-6 mb-3 mb-lg-2">
                      <label for="" class="d-flex align-items-center">{{ProductHeaderCol['ItemCode']}}</label>
                      <angular2-multiselect [settings]="dropdownSetting3" [data]="showmodel" [(ngModel)]="selectedmodel"
                        (onSelect)="onModelSelect($event)" (onDeSelect)="onModelSelect($event)"
                        (onSelectAll)="onModelSelect($event)" (onDeSelectAll)="onModelSelect($event)" fixSearchBug>
                      </angular2-multiselect>
                    </div>

                    <div class="col-auto mb-2 mb-lg-0">
                      <label for="" class="d-none d-lg-block">&nbsp;</label>
                      <a href="javascript:void(0);" title="Apply"
                        class="btn btn-outline-info d-flex align-items-center btn-new-light-info"
                        (click)="onSubmit()"><i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> Apply
                      </a>
                    </div>
                    <div class="col-auto mb-2 mb-lg-0">
                      <label for="" class="d-none d-lg-block">&nbsp;</label>
                      <a href="javascript:void(0);"
                        class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Reset"
                        (click)="resetData()">
                        <i class="mdi mdi-reload mdi-18px"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">

                    <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                      style="width: 250px !important; float: right;">
                      <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword"
                        placeholder="Search" (keyup.enter)="dynamicList()" /><span
                        class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                        style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;"
                        (click)="dynamicList();"></span>
                      <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                        title="Clear">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                          class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData(); dynamicList()"
                          (clearEvent)="searchword=''" *ngIf="searchword">
                          <path
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                      </span>
                    </mat-form-field>

                    <table class="table" mat-table matSorts [dataSource]="ProductList" matSort
                      [matSortActive]="'objHeader'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
                      [multiTemplateDataRows]="true" (matSortChange)="onSortData($event)" aria-hidden="true">

                      <ng-container matColumnDef="{{ProductHeaderCol[col]}}"
                        *ngFor="let col of ProductHeaderKey; index as i;">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ProductHeaderCol[col]}}
                          <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!=ProductHeaderCol[col]"><img
                            src="assets/images/sort_up.png" alt=""
                            *ngIf="upicon && !downicon && columnsort == ProductHeaderCol[col]"><img
                            src="assets/images/sort_down.png" alt=""
                            *ngIf="downicon && !upicon && columnsort == ProductHeaderCol[col]">
                        </th>
                        <ng-container *ngIf="productValues[col] != 'VatRate' && productValues[col] != 'StatusName'">
                          <td mat-cell *matCellDef="let element">{{element[productValues[col]]}}</td>
                        </ng-container>
                        <ng-container *ngIf="productValues[col] == 'VatRate' && productValues[col] != 'StatusName'">
                          <td mat-cell *matCellDef="let element">{{element[productValues[col]] | number : '1.2-2'}}</td>
                        </ng-container>
                        <ng-container *ngIf="productValues[col] == 'StatusName'">
                          <td mat-cell *matCellDef="let element" [title]="element[productValues['StatusRemark']]">{{
                            element[productValues[col]] }}</td>
                        </ng-container>
                      </ng-container>

                      <ng-container matColumnDef="Action">
                        <th mat-header-cell *matHeaderCellDef><span class="mdi mdi-settings"></span></th>
                        <td mat-cell *matCellDef="let element">
                          <div ngbDropdown class="d-block list-dropdown-box">
                            <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1"
                              ngbDropdownToggle> <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                              <div class="d-block">

                                <a *ngIf="element.StatusName=='Inactive'" class="" placement="bottom"
                                  href="javascript:void(0);" title="Active"
                                  (click)="openStatusModel(statusConfirm,element.ProductId,'1', item.itemName, element.CategoryName, element.Code)"><button
                                    ngbDropdownItem><i class="mdi mdi-eye-off"></i>Status</button></a>

                                <a *ngIf="element.StatusName=='Active'" class="" placement="bottom"
                                  href="javascript:void(0);" title="Inactive"
                                  (click)="openStatusModel(statusConfirm,element.ProductId,'2', item.itemName, element.CategoryName, element.Code)"><button
                                    ngbDropdownItem><i class="mdi mdi-eye"></i>Status</button></a>

                                <div *ngIf="permission.Product_Edit==1 || userRId==1">
                                  <a href="javascript:void(0);" class="" placement="bottom"
                                    (click)="edit(element.ProductId)"><button ngbDropdownItem><i class="mdi mdi-pencil"
                                        style="color:green"></i>Edit</button>
                                  </a>
                                </div>

                                <div *ngIf="permission.Product_Delete==1 || userRId==1">
                                  <a href="javascript:void(0);" class="" placement="bottom"
                                    (click)="deleteOpenModal(deleteConfirm,element.ProductId,'3', item.itemName, element.CategoryName, element.Code)">
                                    <button ngbDropdownItem><i class="mdi mdi-delete" style="color:red"></i>
                                      Delete</button></a>
                                </div>

                              </div>
                            </div>
                          </div>
                        </td>
                      </ng-container>

                      <tr class="odd" mat-header-row *matHeaderRowDef="ProductHeader"></tr>
                      <tr mat-row *matRowDef="let row; columns: ProductHeader;"></tr>
                    </table>

                    <div *ngIf="totalSize == 0" class="text-center">
                      No Record found.
                    </div>

                    <div *ngIf="totalSize > 0">
                      <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize"
                        showFirstLastButtons aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                        (page)="handlePage($event)" [pageSize]="pageSize">
                      </mat-paginator>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</div>

<ng-template #statusConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Product Status Change</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide(); clear()" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Business Vertical - {{file}}</strong></p>
    <p class="text-left mb-2"><strong>Business Category - {{vertical}}</strong></p>
    <p class="text-left mb-2"><strong>Item Code - {{code}}</strong></p>
    <form [formGroup]="StatusForm">
      <p class="text-left mb-2"><strong>Remark :</strong></p>
      <textarea class="form-control" maxlength="200" formControlName="Remark" (input)="NameSpaceNotAllowed($event)"
        [ngClass]="{ 'is-invalid': submitted1 && StatusForm.get('Remark').errors }"></textarea>
      <div
        *ngIf="StatusForm.get('Remark').invalid && StatusForm.get('Remark').errors && (StatusForm.get('Remark').dirty || StatusForm.get('Remark').touched) || submitted1">
        <small class="text-danger" *ngIf="StatusForm.get('Remark').hasError('required')">
          Remark is Required
        </small>
      </div>
    </form><br>
    <p class="text-left mb-2"> Are you sure you want to change the status ?</p>
  </div>

  <div class="modal-footer">
    <button href="javascript:void(0);" type="submit" class="btn btn-info btn-sm" (click)="makeActiveInactive()"
      [disabled]="delNameDel">Change Status</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide(); clear()">Cancel</button>
  </div>
</ng-template>

<!--Delete modal-->
<ng-template #deleteConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Product Delete</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Business Vertical - {{category}}</strong></p>
    <p class="text-left mb-2"><strong>Business Category - {{vertical}}</strong></p>
    <p class="text-left mb-2"><strong>Item Code - {{code}}</strong></p>
    <p class="text-left mb-2">Do you want to delete this row ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="deleteProduct(); modalRef.hide();"
      [disabled]="delNameDel">Delete</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<!--Import Product -->
<div class="modal fade" bsModal #importDocument="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Import Product</h4>
        <button type="button" class="close pull-right" aria-label="Close"
          (click)="importDocument.hide();rtnView();"><span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Upload Document</label>
                <input type="file" id="" class="form-control" (change)="onChange($event)" accept=".xlsx" #inputFile>
              </div>
              <p class="text-info mb-0 mt-1"><a href="{{Sample_Product}}Sample_Product.xlsx">Download Sample File</a>
              </p>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="import();"
          [disabled]="multiClick">Import</button>
        <input #showimport (click)="ImportResult.show()" type="hidden">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
          (click)="importDocument.hide();rtnView();">Close</a>
      </div>
    </div>
  </div>
</div>

<!--Start Product Import Result modal-->
<div class="modal fade" bsModal #ImportResult="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Product Import Result</h4>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Total Records:
                  <span class="font-weight-bold">{{Totalrec}} </span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Successful Records:
                  <span class="font-weight-bold">{{valid}}</span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Invalid Records:
                  <span class="font-weight-bold d-inline-block" (click)="openClose()" style="cursor:pointer">
                    {{invalid}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-row animated fadeIn" *ngIf="isCollapsed1">
            <div class="col-lg-12 col-md-12">
              <div class="table-responsive" style="max-height: 300px;">
                <table class="table mb-0" aria-hidden="true">
                  <tbody>
                    <tr *ngFor="let item of dataarray; let i = index">
                      <td>Row {{item.Row}}</td>
                      <td>{{item.Error}} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="ImportResult.hide();rtnView()">OK</a>
      </div>
    </div>
  </div>
</div>
<!-- End Product Import Result modal-->

<!--Import-->
<div class="modal fade" bsModal #addDocument="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Import</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="addDocument.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Upload Document</label>
                <input type="file" id="" class="form-control" (change)="onChange($event)" accept=".xlsx" #inputFile>
              </div>
              <p class="text-info mb-0 mt-1"><a
                  href="http://43.229.227.26:81/mavenCRM/Uploads/Excel/Sample_Product.xlsx" download>Sample File</a></p>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="import();addDocument.hide();">Import</a>
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2" (click)="addDocument.hide()">Close</a>
      </div>
    </div>
  </div>
</div>

<!--Export-->
<ng-template #exportConfirm>
  <div class="modal-content animated zoomIn">
    <div class="modal-header">
      <h4 id="dialog-static-name" class="modal-title pull-left">Export Product</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="decline();">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      <select class="form-control" [(ngModel)]="exportBusiness">
        <option [ngValue]="All">All</option>
        <option [ngValue]="item.id" *ngFor="let item of businessStream; index as i;">{{item.itemName}}</option>
      </select>
      <p class="mt-3">Do you want to export?</p>
      <button type="button" class="btn btn-info btn-sm" (click)="exportProduct(); modalRef.hide();"
        [disabled]="exportName">Export</button>
      <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide();">Close</button>
    </div>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>